// extracted by mini-css-extract-plugin
export default {"tab":"tab-module--tab--BrrIv","title":"tab-module--title--IKxzH","children":"tab-module--children--1kqDC","isActive":"tab-module--is-active--3imES"};